export const SET_SHOW_MODAL_POST = 'SET_SHOW_MODAL_POST';
export const SET_HIDE_MODAL_POST = 'SET_HIDE_MODAL_POST';
export const CLEAR_VISORIAS_STATE = 'CLEAR_VISORIAS_STATE ';
export const SET_NEW_VISORIA_POST = 'SET_NEW_VISORIA_POST';
export const SET_ALL_VISORIAS_POST = 'SET_ALL_VISORIAS_POST';